import { atom } from 'jotai'

export const additionalConfiguration = atom([])
